import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class MarriageTerminationReason extends Enum {
  key!: string;
  value!: string;

  static DIVORCE: MarriageTerminationReason = {
    key: 'divorce',
    get value(): string {
      return Lang.t('contact.divorce');
    }
  };

  static DEATH_OF_SPOUSE: MarriageTerminationReason = {
    key: 'death_of_spouse',
    get value(): string {
      return Lang.t('contact.death-of-spouse');
    }
  };

  static DECLARATION_OF_NULLITY: MarriageTerminationReason = {
    key: 'declaration_of_nullity',
    get value(): string {
      return Lang.t('contact.declaration-of-nullity');
    }
  };

  static DISSOLUTION_OF_RELATIONSHIP: MarriageTerminationReason = {
    key: 'dissolution_of_relationship',
    get value(): string {
      return Lang.t('contact.dissolution-of-relationship');
    }
  };
}
